import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';

import authSlice from '../features/authentication/authSlice';
import { apiSlice } from '../api/apiSlice';

const isDevelopment = process.env.NODE_ENV !== 'production';

const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        [authSlice.name]: authSlice.reducer
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            immutableCheck: isDevelopment
                ? {
                    warnAfter: 128,
                    ignoredPaths: [apiSlice.reducerPath]
                }
                : false,
            serializableCheck: isDevelopment
                ? {
                    warnAfter: 128,
                    ignoredPaths: [apiSlice.reducerPath],
                    ignoredActionPaths: ['payload.tapahtumat', 'meta.baseQueryMeta', 'meta.arg.originalArgs']
                }
                : false
        }).concat(apiSlice.middleware),
    devTools: true
});

setupListeners(store.dispatch);

export default store;